export default __webpack_public_path__ + "static/media/08.e0077d54.png";